/**
 * NO SECRETS ALLOWED HERE.
 */

import SiteConfig from "./SiteConfig";
import { IPublicSettings } from "@/src/@types/Settings";
import * as process from "process";

// Note we use || here instead of ?? because a blank string should be considered undefined. Netlify tends to use blank strings if an env var is defined but not set.
export const PublicSettings: IPublicSettings = {
    ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT || "development",
    BRAND_ID: process.env.NEXT_PUBLIC_BRAND_ID || "default",
    HREFLANG_DEFAULT_URL: process.env.NEXT_PUBLIC_HREFLANG_DEFAULT_URL || "https://spotpet.dev",
    CANONICAL_URL_ROOT: process.env.NEXT_PUBLIC_CANONICAL_URL_ROOT || "http://localhost:3000",
    COOKIE_DOMAIN: process.env.NEXT_PUBLIC_COOKIE_DOMAIN || ".spotpet.com",
    SPOT_API_DOMAIN: process.env.NEXT_PUBLIC_SPOT_API_DOMAIN || "https://dev-api.spotpet.com",
    BUILDER_IO_PUBLIC_API_KEY: process.env.NEXT_PUBLIC_BUILDER_IO_PUBLIC_API_KEY ?? "e0e4313549ac4efa9fbefb8c6275dc1d",
    BUILDER_IO_PAGE_MODEL: process.env.NEXT_PUBLIC_BUILDER_IO_PAGE_MODEL ?? "landing-page",

    SEGMENT_CDN_URL: process.env.NEXT_PUBLIC_SEGMENT_CDN_URL ?? "analytics.spotpet.com",
    SEGMENT_API_URL: process.env.NEXT_PUBLIC_SEGMENT_API_URL ?? "segment.spotpet.com/v1",
    SEGMENT_WEB_WRITE_KEY: process.env.NEXT_PUBLIC_SEGMENT_WEB_WRITE_KEY,

    DISABLE_SEARCH_ENGINE_INDEXING: process.env.NEXT_PUBLIC_DISABLE_SEARCH_ENGINE_INDEXING === "true",

    DATADOG_CLIENT_TOKEN: process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN ?? "pub722e1d5ae91c43c471a840b4c4fe1748",
    DATADOG_APPLICATION_ID: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_ID ?? "0772eb70-1279-4f61-95b8-10e164fd0f25",
    DATADOG_SITE_NAME: process.env.NEXT_PUBLIC_DATADOG_SITE_NAME || "spot-web-us",
    DATADOG_APPLICATION_VERSION: process.env.NEXT_PUBLIC_DATADOG_APPLICATION_VERSION,
    DATADOG_SESSION_SAMPLE_RATE: process.env.NEXT_PUBLIC_DATADOG_SESSION_SAMPLE_RATE,
    DATADOG_SESSION_RECORD_RATE: process.env.NEXT_PUBLIC_DATADOG_SESSION_RECORD_RATE,

    LINK_FOLLOW_DOMAIN_WHITELIST: (process.env.NEXT_PUBLIC_LINK_FOLLOW_DOMAIN_WHITELIST ?? "").split(","),

    QUOTE_FORM_URL_ROOT: process.env.NEXT_PUBLIC_QUOTE_FORM_URL_ROOT || "https://quote.spotpet.dev",
    MEMBER_CENTER_URL_ROOT: process.env.NEXT_PUBLIC_MEMBER_CENTER_URL_ROOT || "https://app.spotpet.dev",
    CS_PHONE_NUMBER: process.env.NEXT_PUBLIC_CS_PHONE_NUMBER || "800-905-1595",
    CS_PHONE_NUMBER_DISPLAY: process.env.NEXT_PUBLIC_CS_PHONE_NUMBER_DISPLAY || "800-905-1595",
    CS_EMPLOYER_PHONE_NUMBER: process.env.NEXT_PUBLIC_CS_EMPLOYER_PHONE_NUMBER || "888-343-2340",

    SAASQUATCH_NAMESPACE_ID: process.env.NEXT_PUBLIC_SAASQUATCH_NAMESPACE_ID || `5be99b20-860e-4153-bf04-eb68270f1470`,
    SAASQUATCH_TENANT_ALIAS: process.env.NEXT_PUBLIC_SAASQUATCH_TENANT_ALIAS || `test_aoxkqgkpckxbo`,
    SAASQUATCH_PROGRAM_ID: process.env.NEXT_PUBLIC_SAASQUATCH_PROGRAM_ID || `spot-refer-a-friend`,
    SAASQUATCH_WIDGET_ID: process.env.NEXT_PUBLIC_SAASQUATCH_WIDGET_ID || `referrerWidget`,

    BASE_PATH: process.env.NEXT_PUBLIC_BASE_PATH || "/",
    // Sets test URL to deploy preview URL if on CI/CD
    TEST_SITE_ROOT: process.env.PLAYWRIGHT_TEST_BASE_URL || `http://localhost:3000`,

    SPOT_MARKETING_EMAIL: process.env.NEXT_PUBLIC_SPOT_MARKETING_EMAIL || "marketing@spotpet.com",

    STATSIG_CLIENT_KEY: process.env.NEXT_PUBLIC_STATSIG_CLIENT_KEY,
    STATSIG_LAYER_MAIN: process.env.NEXT_PUBLIC_STATSIG_LAYER_MAIN || "web-main",

    QUOTE_WIDGET_BASE_URL: process.env.NEXT_PUBLIC_QUOTE_WIDGET_BASE_URL || "https://quote.spotpet.dev",
    QUOTE_WIDGET_SCRIPT_URL: process.env.NEXT_PUBLIC_QUOTE_WIDGET_SCRIPT_URL || "https://d1zhwgcr12yw7n.cloudfront.net/latest/spot-widget/spot-widget.min.js",
    QUOTE_WIDGET_EMPLOYERS_ON_BY_DEFAULT: process.env.NEXT_PUBLIC_QUOTE_WIDGET_EMPLOYERS_ON_BY_DEFAULT === "true",

    // Osano
    OSANO_CMP_SRC: process.env.NEXT_PUBLIC_OSANO_CMP_SRC || "https://cmp.osano.com/AzZnQYUKjmniQ4Zwf/9bed93f2-cdde-4d98-b2ff-48d6f6697c70/osano.js",

    // Google Analytics 4, loaded site-wide as on-page gtag.js in pages/_document.tsx
    // (the quote app on quote.spotpet.com gets GA4 via GTM-TBMNRSX instead)
    GA4_MEASUREMENT_ID: process.env.NEXT_PUBLIC_GA4_MEASUREMENT_ID || "G-5X75GNN1CJ",

    ...SiteConfig.publicSettingsOverride
};
